// Mock data for Ascend Higher landing page clone

export const navLinks = [
  { label: "How It Works", href: "#how-it-works" },
  { label: "Pricing", href: "#pricing" },
  { label: "About", href: "#about" },
];

export const howItWorks = [
  {
    number: "01",
    title: "Answer a few questions",
    description:
      "Tell Ascend where you are and what you want to improve — your goals, habits, schedule, health, money, and relationships.",
  },
  {
    number: "02",
    title: "Get your life snapshot",
    description:
      "Receive a personalized life snapshot and a daily roadmap built around your actual situation — not generic advice.",
  },
  {
    number: "03",
    title: "Check in every day",
    description:
      "Talk to your AI mentor each day. It remembers everything you've shared and helps you keep adjusting your plan as life changes.",
  },
];

export const firstThreeDays = [
  {
    day: "Day 0",
    title: "Get your Current Life Snapshot",
    description:
      "Answer a few honest questions. Receive your personalized life snapshot and your first simple action plan.",
  },
  {
    day: "Day 1",
    title: "Stabilize and simplify",
    description:
      "Your first mentor check-in. Clarify what matters most right now. Cut through the noise and find one clear next step.",
  },
  {
    day: "Day 2",
    title: "Build your 7-day roadmap",
    description:
      "Map out a practical week across your goals, habits, schedule, health, money, and relationships.",
  },
  {
    day: "Day 3",
    title: "Review your progress",
    description:
      "See how far you've come and preview your next 30 days. Decide if Ascend is right for your journey.",
  },
];

export const trustBadges = [
  { icon: "Lock", label: "Private by design" },
  { icon: "X", label: "Cancel anytime" },
  { icon: "MessageSquare", label: "Not therapy or medical care" },
  { icon: "Calendar", label: "Built for daily guidance" },
  { icon: "Sparkles", label: "AI-powered roadmap" },
  { icon: "Shield", label: "Your data is not sold" },
];

export const problems = [
  {
    symbol: "$",
    title: "Coaching is expensive",
    description:
      "Quality coaching costs $150–300/hr. Most people can't afford it — but they still need direction.",
  },
  {
    symbol: "//",
    title: "Fragmented tools",
    description:
      "One app for habits. Another for journaling. Nothing connects or remembers your full picture.",
  },
  {
    symbol: "~",
    title: "No daily system",
    description:
      "Inspiration is easy to find. A consistent daily system you can actually follow is much harder.",
  },
];

export const pricingPlans = [
  {
    badge: "DAILY AI ROADMAP",
    badgeVariant: "blue",
    name: "Basic",
    price: "$8.88",
    period: "/mo",
    annualPrice: "$98.88/year",
    annualNote: "about $8.24/month, billed annually",
    features: [
      "Personalized AI life roadmap",
      "5-pillar life structure",
      "Daily goals & habit guidance",
      "Daily check-ins & progress tracking",
      "Awareness & clarity practices",
    ],
    ctaLabel: "Start 3-Day Free Trial",
    footnote: "No charge today. Cancel anytime.",
    ctaVariant: "blue",
  },
  {
    badge: "DEEP AI COACH",
    badgeVariant: "green",
    name: "Advanced",
    price: "$28.88",
    period: "/mo",
    annualPrice: "$308.88/year",
    annualNote: "about $25.74/month, billed annually",
    features: [
      "Everything in Basic",
      "Deeper AI coaching with longer conversations",
      "Voice coaching — talk to your coach",
      "Persistent memory across sessions",
      "Weekly insights & pattern read",
      "Coach can adjust your roadmap mid-chat",
    ],
    ctaLabel: "Start 3-Day Free Trial",
    footnote: "No charge today. Cancel anytime.",
    ctaVariant: "green",
  },
];

export const testimonial = {
  quote:
    "I built Ascend because I needed it. I spent 40 years as the family scapegoat. Every win was weaponized. I built a business with my father and watched him use my success against me. When I finally left, I had no coach, no mentor, no one checking in. Ascend is the system I wish I'd had.",
  author: "Eric",
  role: "Founder",
};
